import React from 'react';

const FireIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      d="M12 2.05c-1.1 2.1-2.4 3.9-4.1 5.2-1.5 1.1-2.6 2.8-2.8 4.7-0.2 1.9 0.5 3.9 1.8 5.4 1.1 1.2 2.6 2 4.3 2.2 2.1 0.3 4.2-0.4 5.8-1.9 1.7-1.6 2.6-3.8 2.6-6.1 0-2.9-1.5-5.6-3.8-7.5C14.6 2.85 13.2 2 12 2.05z"
    />
  </svg>
);

export default FireIcon;
